import { _any } from "i18n";

const MISSING_ASSIGNED_GAME_VALUE = "-";

export function displayAssignedGameText(value?: string | number | null): string {
	if (value == null || value === "") {
		return MISSING_ASSIGNED_GAME_VALUE;
	}
	return String(value);
}

export function formatAssignedGameId(gameId?: number | null): string {
	if (gameId == null) {
		return MISSING_ASSIGNED_GAME_VALUE;
	}
	return `#${gameId}`;
}

export function formatAssignedGameClubMatchup(
	homeClubName?: string | null,
	awayClubName?: string | null,
): string {
	const homeClubLabel = displayAssignedGameText(homeClubName);
	const awayClubLabel = displayAssignedGameText(awayClubName);
	if (homeClubLabel === MISSING_ASSIGNED_GAME_VALUE && awayClubLabel === MISSING_ASSIGNED_GAME_VALUE) {
		return MISSING_ASSIGNED_GAME_VALUE;
	}
	return `${homeClubLabel} - ${awayClubLabel}`;
}

export function formatAssignedGameTypeAndDate(gameType?: string | null, date?: string | null): string {
	const parts: string[] = [];
	if (gameType != null && gameType !== "") {
		parts.push(_any(`enum.gametype.${gameType}`));
	}
	if (date != null && date !== "") {
		parts.push(date);
	}
	if (parts.length === 0) {
		return MISSING_ASSIGNED_GAME_VALUE;
	}
	return parts.join(" ");
}

export function hasAssignedGameDetail<T extends { id?: number }>(
	game?: T | null,
): game is T & { id: number } {
	return game != null && Number.isFinite(game.id);
}
